
  Vue.component('vue-visualizer', {
    props: {
      vvKey: { type: String, required: true },
      vvLabel: String,
      vvVisible: Boolean,
      vvShowFunction: Function,
      vvHideFunction: Function,
      vvToggleFunction: Function
    },
    data() {
      return {
        container: null
      }
    },
    template: '#vue-visualizer',
    computed: {},
    watch: {},
    methods: {
      vvToggle(param) {
        if (param.key && param.key === this.vvKey) {
          if (this.vvToggleFunction) {
            this.vvToggleFunction()
          } else {
            $(this.container).toggleClass('d-none')
          }
        } else {
          console.log('vvToggle NOT MATCH', param, this.vvKey)
        }
      },
      vvShow(param) {
        if (param.key && param.key === this.vvKey) {
          if (this.vvShowFunction) {
            this.vvShowFunction()
          } else {
            $(this.container).removeClass('d-none')
          }
        } else if (param.hideOthers) {
          $(this.container).addClass('d-none')
        }
      },
      vvHide(param) {
        if (param.key && param.key === this.vvKey) {
          if (this.vvHideFunction) {
            this.vvHideFunction()
          } else {
            $(this.container).addClass('d-none')
          }
        }
      }
    },
    mounted() {
      this.container = document.getElementById(this.$root.$el.id).parentNode
      EventBus.$on('vvToggle', this.vvToggle)
      EventBus.$on('vvShow', this.vvShow)
      EventBus.$on('vvHide', this.vvHide)
    },
    beforeDestroy() {
      EventBus.$off('vvToggle', this.vvToggle)
      EventBus.$off('vvShow', this.vvShow)
      EventBus.$off('vvHide', this.vvHide)
    }
  })
